import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useCoreApi } from '../api';
import { coreKeys } from '../query-key-factory';

export function useDeletePaymentMethodV2() {
  const CoreApi = useCoreApi();
  const queryClient = useQueryClient();

  const deleteCreditCard = async (uuid: string) => {
    await CoreApi.delete(`/v2/payment_methods/${uuid}`);
    return;
  };

  return useMutation({
    mutationFn: deleteCreditCard,
    onSuccess() {
      void queryClient.invalidateQueries({
        queryKey: coreKeys.user.paymentMethods.all,
      });
    },
  });
}
